import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import manageIcon from '../../../images/manage-icon.png';
import deleteIcon from '../../../images/icon-trash.svg';
import { deleteTrainingProgram, duplicateTrainingProgram} from '../../../redux/slices/admin/trainingSlice';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import ManageProgramModal from './ManageProgramModal';

const ProgramsTable = ({ onEdit, handlePageChange }) => {
  const dispatch = useDispatch();
  const { programs, currentPage, totalPages } = useSelector((state) => state.trainingPrograms);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [selectedProgram, setSelectedProgram] = useState(null);
  const [selectedProgramDays, setSelectedProgramDays] = useState(0);
  const [selectedProgramWeeks, setSelectedProgramWeeks] = useState(0);

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
  const toggleDropdown = (id, event) => {
    if (activeDropdown === id) { 
      setActiveDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setActiveDropdown(id);
    }
  };

  const handleDelete = (id) => {
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this program?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => dispatch(deleteTrainingProgram(id))
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  const handleDuplicate = (id) => {
    confirmAlert({
      title: 'Confirm Duplicate',
      message: 'Are you sure you want to Duplicate this program?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => dispatch(duplicateTrainingProgram({id:id,currentPage:currentPage}))
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };  

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOpenModal = (program) => {
    setSelectedProgram(program);
    setSelectedProgramWeeks(program.weeks || 0);
    setSelectedProgramDays(program.days || 0);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

   const handleScroll = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <>
    <div className="table-responsive">
        <table className="table table-striped table-users table-alex printarea">
          <thead>
            <tr>
              <th>Image</th>
              <th>Program Name</th>
              <th>Status</th>
              <th>User Type</th>
              <th>Duplicate</th>
              <th>Details</th>
              <th className="noprint">Action</th>
            </tr>
          </thead>
          <tbody>
            {programs && programs.length > 0 ? (
              programs.map((program) => (
                <tr key={program.id}>
                 <td>
                  <div className="text-start d-flex align-items-center">
                    <div className="img-placeholder me-2">
                      {program.image_full_url ? (
                        <img src={program.image_full_url} alt={program.program_name || 'Program'} className="img-thumbnail" />
                      ) : (
                        <p>No Image</p>
                      )}
                    </div>
                  </div>
                </td>

                  <td>
                    <div>{program.program_name}</div>
                  </td>
                  <td>{program.status == 1 ? 'Active':'Inactive'}</td>

                  <td>
                    <div>{program.user_type}</div>
                  </td>

                  <td>
                    <a className="btn btn-create w-10" onClick={() => handleDuplicate(program.id)}>
                      Duplicate
                    </a>
                  </td>

                  <td>
                    <div>Gender: {program.gender}</div>
                    <div>Weeks: {program.weeks} Days: {program.days}</div>
                  </td>
                  <td className="noprint">
                    <div className="text-center position-relative" ref={dropdownRef}>
                      <button 
                        type="button" 
                        className="bg-transparent border-0 p-0 btn-vert-dots" 
                        onClick={(e) => toggleDropdown(program.id, e)}
                      >
                        <img src={optionsIcon} alt="Options" />
                      </button>
                      {activeDropdown === program.id && (
                        <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `200px`,
                            zIndex: 1050, }}
                      >  
                          <li>
                            <a className="dropdown-item" onClick={() => onEdit(program)}>
                              <img src={editIcon} alt="Edit" /> Edit
                            </a>
                          </li>

                          {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                          <li>
                            <a className="dropdown-item" onClick={() => handleDelete(program.id)}>
                              <img src={deleteIcon} alt="Delete" /> Delete
                            </a>
                          </li>
                          )}

                          <li>
                            <a className="dropdown-item" onClick={() => handleOpenModal(program)}>
                              <img src={manageIcon} alt="Manage" /> Manage
                            </a>
                          </li>
                        </ul>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">No programs found.</td>
              </tr>
            )}
          </tbody>
        </table>
       </div>
      <Pagination 
        currentPage={currentPage} 
        totalPages={totalPages} 
        onPageChange={handlePageChange} 
      />
      {showModal && (
        <ManageProgramModal
          isOpen={showModal}          
          handleCloseModal={() => handleCloseModal()}
          selectedProgramWeeks={selectedProgramWeeks}
          selectedProgramDays={selectedProgramDays} 
          selectedProgram={selectedProgram}
        />
      )}
    </>
  );
};

export default ProgramsTable;